import { combineReducers } from 'redux';

import apiError from './apiError';
import isLoading from './isLoading';
import isReady from './isReady';
import isUpdating from './isUpdating';
import languages from './languages';
import selectedId from './selectedId';
import selectedLocale from './selectedLocale';

/**
 * @typedef {{
 *   selectedId: string,
 *   isLoading: boolean,
 *   isReady: boolean,
 *   isUpdating: boolean,
 *   apiError: string,
 *   languages: string[],
 *   selectedLocale: string
 * }} QuestionModelsUIDetailsReducer
 */

export default combineReducers({
  selectedId,
  isLoading,
  isReady,
  isUpdating,
  apiError,
  languages,
  selectedLocale,
});
